import React, { useState } from "react";
//import Search from 

export default function TemplateFilter({
  category,
  setCategory,
  search,
  setSearch,
  searchType,
  setSearchType,
  handleSearch
}) {
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [searchTypeDropdownOpen, setSearchTypeDropdownOpen] = useState(false);

  const categories = ["전체", "회계", "행사/사업", "행정/운영", "기타"];

  const searchTypes = [
    { value: "title", label: "제목" },
    { value: "writer", label: "내용" },
  ];

  const selectedSearchType =
    searchTypes.find((item) => item.value === searchType)?.label || "제목";


  return (
    <div className="stdcouncil-template-filter">

      <div className="stdcouncil-template-filter-left">
        <div className="stdcouncil-template-dropdown">
          <button
            className="stdcouncil-template-dropdown-btn"
            onClick={() => setCategoryDropdownOpen((v) => !v)}
            type="button"
          >
            {category}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: categoryDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s"
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {categoryDropdownOpen && (
            <ul className="stdcouncil-template-dropdown-list">
              {categories.map((item) => (
                <li
                  key={item}
                  className={`stdcouncil-template-dropdown-item ${category === item ? "active" : ""}`}
                  onClick={() => {
                    setCategory(item);
                    setCategoryDropdownOpen(false);
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="stdcouncil-template-filter-right">

        <div className="stdcouncil-template-dropdown">
          <button
            className="stdcouncil-template-dropdown-btn"
            onClick={() => setSearchTypeDropdownOpen((v) => !v)}
            type="button"
          >
            {selectedSearchType}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: searchTypeDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s"
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {searchTypeDropdownOpen && (
            <ul className="stdcouncil-template-dropdown-list">
              {searchTypes.map((item) => (
                <li
                  key={item.value}
                  className={`stdcouncil-template-dropdown-item ${searchType === item.value ? "active" : ""}`}
                  onClick={() => {
                    setSearchType(item.value);
                    setSearchTypeDropdownOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="stdcouncil-template-search-wrap">
          <input
            className="stdcouncil-template-search-input"
            type="text"
            placeholder="검색어를 입력하세요."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />
          <button className="stdcouncil-template-search-btn" onClick={handleSearch}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div>

      </div>
    </div>
  );
}